// 🚨 AUTO-GENERADO desde ProviderRecibeFormDataType.ts - No editar manualmente

export const ProviderRecibeFormDataKeys = [
  "id",
  "created",
  "total",
  "abono",
  "motivo",
  "forma_pago",
  "exchange_rate",
  "reference",
  "numero_recibo",
  "comments",
  "bankAccountId",
  "bankAccount",
  "anulado",
  "creditOperatorId",
  "creditOperator",
  "providerId",
  "provider",
  "currencyId",
  "currency",
  "providerInvoices",
  "user"
] as const;
